export default __webpack_public_path__ + "static/realWorldImg2-a78240770db44928c3045637714935ee.webp";